import React from 'react';

function DivButton({ children, id, handleClick, style }) {
  return (
    <div
      onClick={handleClick}
      id={id}
      data-testid={id}
      css={style}
      role='button'
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === 'Enter') {
          handleClick();
        }
      }}
    >
      {children}
    </div>
  );
}

export default DivButton;
